// extracted by mini-css-extract-plugin
export default {"disable_options":"UsersManagement_disable_options__Nht4p"};